import {call, put, takeLatest} from "redux-saga/effects";
import request from "../../api/request";
import { isNullOrUndefined } from "../../utils/functionsUtils";

function* getAllCities(payload) {
  try {
    const includeAllValue = isNullOrUndefined(payload.value.includeAll) ? '' : payload.value.includeAll;
    
    yield put({
      type: "FETCH_CITIES_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/cities?page=${payload.value.page}&search=${payload.value.search}&offset=${payload.value.offset}${payload.value.isActive ? '&isActive=' + payload.value.isActive: ''       
    }&includeAll=${includeAllValue}`;
    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });

    yield put({
      type: "FETCH_CITY_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed load",
        message: "Failed load Cities",
      },
    });
    yield put({
      type: "FETCH_CITY_ERROR",
    });
  }
}

function* postCity(payload) {
  try {
    yield put({ type: "CREATE_CITY_REQUESTING" });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/cities`;

    const headers = {
      method: "POST",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Successful save",
        message: "Successful save City",
      },
    });
    yield put({
      type: "CREATE_CITY_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed save",
        message: "Failed save City",
      },
    });
    yield put({
      type: "CREATE_CITY_ERROR",
    });
  }
}

function* getCityById(payload) {
  try {
    yield put({
      type: "READ_CITY_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/cities/${payload.value.id}`;

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });

    yield put({
      type: "READ_CITY_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "READ_CITY_ERROR",
    });
  }
}

function* deleteCityById(payload) {
  try {
    yield put({
      type: "DELETE_CITY_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/cities/changeState/${payload.value.idCity}`;

    const headers = {
      method: "PATCH",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: payload.value.isActive === false ? "Successful enable" : "Successful disable",
        message: payload.value.isActive === false
          ? "Successful enable City"
          : "Successful disable City",
      },
    });
    yield put({
      type: "DELETE_CITY_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed disable",
        message: "Failed disable City",
      },
    });
    yield put({
      type: "DELETE_CITY_ERROR",
    });
  }
}

function* updateCity(payload) {
  try {
    yield put({
      type: "UPDATE_CITY_REQUESTING",
    });

    yield put({
      type: "SHOW_LOADING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/cities/${payload.value.id}`;

    const headers = {
      method: "PATCH",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
      body: JSON.stringify(payload.value),
    };

    const response = yield call(request, requestURL, headers);

    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "success",
        title: "Successful update",
        message: "Successful update City",
      },
    });
    yield put({
      type: "UPDATE_CITY_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "HIDE_LOADING",
    });
    yield put({
      type: "SHOW_ALERT",
      value: {
        type: "danger",
        title: "Failed update",
        message: "Failed update City",
      },
    });
    yield put({
      type: "UPDATE_CITY_ERROR",
    });
  }
}

function* getCitiesByDepartmentId(payload) {
  try {
    yield put({
      type: "READBYDEPARTMENT_CITY_REQUESTING",
    });

    const requestURL = `${process.env.REACT_APP_API_URL}/api/v1/cities/department/${payload.value.idDepartment}`;

    const headers = {
      method: "GET",
      headers: new Headers({
        Authorization: `Bearer ${window.localStorage.getItem("token")}`,
        "Content-Type": "application/json",
      }),
    };
    const response = yield call(request, requestURL, headers);

    yield put({
      type: "READBYDEPARTMENT_CITY_SUCCESS",
      value: response,
    });
  } catch (error) {
    yield put({
      type: "READBYDEPARTMENT_CITY_ERROR",
    });
  } finally {
    yield put({
      type: "HIDE_LOADING",
    });
  }
}

export function* watchCity() {
  yield takeLatest("FETCH_CITIES_REQUEST", getAllCities);
  yield takeLatest("CREATE_CITY_REQUEST", postCity);
  yield takeLatest("READ_CITY_REQUEST", getCityById);
  yield takeLatest("DELETE_CITY_REQUEST", deleteCityById);
  yield takeLatest("UPDATE_CITY_REQUEST", updateCity);
  yield takeLatest("READBYDEPARTMENT_CITY_REQUEST", getCitiesByDepartmentId);
}
